import React, { useEffect, useState } from "react";
import { transformToHtml } from "../../../utils/CommonUtils";
import FlightStatusListingCard from "../FlightStatusListing/FlightStatusListingCard";

const TAB_DEPARTURES = "departures";
const TAB_ARRIVALS = "arrivals";

export default function FlightStatusAirportListing({ listing, h1Header, showListingTitle = true }) {
  const departures = listing?.departures;
  const arrivals = listing?.arrivals;
  const hasDepartures = Boolean(departures?.cards?.length);
  const hasArrivals = Boolean(arrivals?.cards?.length);

  const [activeTab, setActiveTab] = useState(
    hasDepartures ? TAB_DEPARTURES : TAB_ARRIVALS,
  );

  useEffect(() => {
    if (activeTab === TAB_DEPARTURES && !hasDepartures && hasArrivals) {
      setActiveTab(TAB_ARRIVALS);
    } else if (activeTab === TAB_ARRIVALS && !hasArrivals && hasDepartures) {
      setActiveTab(TAB_DEPARTURES);
    }
  }, [activeTab, hasDepartures, hasArrivals]);

  if (!hasDepartures && !hasArrivals) return null;

  const defaultHeaderTitle = listing?.title || h1Header || "";
  const activePanel = activeTab === TAB_ARRIVALS ? arrivals : departures;
  const activeCards = activePanel?.cards || [];
  const headerTitle = activePanel?.title || defaultHeaderTitle;

  return (
    <section
      className="fs-route-listing fs-airport-listing"
      aria-label={headerTitle || "Airport flight status listing"}>
      {showListingTitle && headerTitle ? (
        <div className="fs-route-listing__header">
          <h1 className="fs-route-listing__title">{transformToHtml(headerTitle)}</h1>
        </div>
      ) : null}
      <div className="fs-airport-listing__tabs" role="tablist" aria-label="Flight direction">
        {hasDepartures ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_DEPARTURES}
            className={`fs-airport-listing__tab${activeTab === TAB_DEPARTURES ? " fs-airport-listing__tab--active" : ""}`}
            onClick={() => setActiveTab(TAB_DEPARTURES)}>
            DEPARTURES
          </button>
        ) : null}
        {hasArrivals ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_ARRIVALS}
            className={`fs-airport-listing__tab${activeTab === TAB_ARRIVALS ? " fs-airport-listing__tab--active" : ""}`}
            onClick={() => setActiveTab(TAB_ARRIVALS)}>
            ARRIVALS
          </button>
        ) : null}
      </div>
      <ul className="fs-route-listing__list" role="tabpanel">
        {activeCards.map((card) => (
          <FlightStatusListingCard key={card.key} card={card} />
        ))}
      </ul>
    </section>
  );
}
